/* eslint-disable react/prop-types */

import React, { useState } from 'react';
import { Card, Col, Row } from 'react-bootstrap';
import { sdDownloadAttachment, sdHtmlToPlainText, sdShowToast, sdTimeAgoFromUTCTimestamp, sdUTCTimestampStrToLocalStr } from 'helpers/sdHelper';
import SDEditor from '../SDEditor';
import { sdUpdateIssue } from 'services/service-desk/sdService';

const SDIssueDetails = ({ issue }) => {
    const [description, setDescription] = useState(issue.description);

    const updateIssueDescription = () => {
        sdUpdateIssue(issue.id, {
            description: description
        }).then(res => {
            console.log("Issue description updated", res);
            sdShowToast("Issue Updated", false);
        }).catch(err => {
            console.error("Failed to update issue", err);
            sdShowToast("Failed to update issue", true);
        });
    }

    if (issue == null) {
        return <></>
    }
    return (
        <Card className="mb-3">
            {/* <Card.Header className="bg-light btn-reveal-trigger d-flex flex-between-center">
                <h5 className="mb-0">Order Summary</h5>
                <Link
                    to="/e-commerce/shopping-cart"
                    className="btn btn-link btn-sm btn-reveal text-600"
                >
                    <FontAwesomeIcon icon="pencil-alt" />
                </Link>
            </Card.Header> */}
            <Card.Body>
                <Row>
                    {/* <Col className="mb-4 mb-lg-0">
                        <h6 className="">Project</h6>
                        <span className="mb-2">{issue.project.name}</span>
                    </Col> */}
                    <Col xs={"auto"} className="mb-4 mb-lg-0">
                        <h6 className="">Created</h6>
                        <span className="mb-2">{`${sdUTCTimestampStrToLocalStr(issue.created)} (${sdTimeAgoFromUTCTimestamp(issue.created)})`}</span>
                    </Col>
                    <Col xs={"auto"} className="mb-4 mb-lg-0">
                        <h6 className="">Updated</h6>
                        <span className="mb-2">{`${sdUTCTimestampStrToLocalStr(issue.updated)} (${sdTimeAgoFromUTCTimestamp(issue.updated)})`}</span>
                    </Col>
                </Row>
                <br></br>
                <SDEditor value={description} onChange={(val) => {setDescription(val)}} onSave={() => {updateIssueDescription();}} fancy></SDEditor>
                {/* {issue.description && issue.description.length > 0 ?
                    <SDEditor initialHtml={issue.description}></SDEditor> :
                    <i>No description exists for this issue.</i>
                } */}


                <div className='d-flex small'>
                    {/* Copy description to clipboard */}
                    <a href="#" onClick={() => {
                        navigator.clipboard.writeText(sdHtmlToPlainText(description))
                            .then(() => {
                                sdShowToast("Copied to clipboard")
                            })
                            .catch(err => {
                                console.error("Failed to copy: ", err);
                            });
                    }}>📋Copy To Clipboard</a>

                    {/* Download original message as eml */}
                    {issue && issue.emailAttachmentId && issue.emailAttachmentId > 0 ?
                        <>
                            <a href="#" className="ms-auto" onClick={() => { sdDownloadAttachment(issue.emailAttachmentId) }}>📩Download original message</a>
                        </> : <></>}
                </div>


            </Card.Body>
            {/* <Card.Footer className="d-flex justify-content-between bg-light">
                <div className="fw-semi-bold">Payable Total</div>
                <div className="fw-bold">$0.0</div>
            </Card.Footer> */}
        </Card>);
}

export default SDIssueDetails;